import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addEmployee = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Employee', body);
  return data;
});
export const updateEmployee = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Employee/${id}`,
    body
  );
  return data;
});

export const getEmployee = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Employee?fields=["name","leave_approver","employee","employee_name","date_of_joining","status","department","designation"]&limit_page_length=10&limit_start=0&order_by=name desc'
  );
  return data;
});
export const deleteEmployee = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Employee/${record}`
  );
  return data;
});
export const getEmployeeDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Employee/${id}`);
  return data;
});
